import { Keyword, Length, Percentage } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either } = Parser;
/**
 * @internal
 */
export const parse = either(Keyword.parse("auto"), Length.parse, Percentage.parse);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/margin-top}
 * @internal
 */
export default Longhand.of(Length.of(0, "px"), parse, (marginTop, style) => marginTop.map((top) => {
    switch (top.type) {
        case "keyword":
        case "percentage":
            return top;
        case "length":
            return top.resolve(Resolver.length(style));
    }
}));
//# sourceMappingURL=margin-top.js.map